import { Store } from "pullstate";

export type Conversation = {
    id: string,
    createdByUserId: string,
    created: string,
    detectedIntent: string,
    score: number,
    status: string,
    messages: Message[],
    participants: Participant[]
}

export type Message = {
    id: string,
    userId: string,
    text: string,
    created: string,
    fileName: string,
    contentType: string
}

export type Participant = {
    id: string,
    userId: string,
    userEmail: string,
    userFullName: string,
    userInitials: string
}

const ChatClientStore = new Store({
    conversations: [] as Conversation[],
    selectedChat: null as null | Conversation,
    showChatWindow: true,
    errorLoadingChats: false,
    loadingConversations: true,
    conversationId: null as null | string,
    status: 'TicketOpen',
    mode: 'SUPPORT'
});

export default ChatClientStore;